var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_5715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33985 7.53418C6.62891 7.54394 7.6543 6.48926 7.66407 5.20019C7.67383 3.9209 6.62891 2.89551 5.33985 2.89551C4.05079 2.89551 3.02539 3.93066 3.02539 5.20996C3.02539 6.49902 4.05079 7.52441 5.33985 7.53418Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33985 9.67285H14.8028C17.3223 9.67285 19.3828 7.87598 19.3828 5.21972C19.3828 2.56348 17.3223 0.766602 14.8028 0.766602H5.33985C2.82032 0.766602 0.759766 2.56348 0.759766 5.21972C0.759766 7.87598 2.82032 9.67285 5.33985 9.67285ZM5.33985 8.19824C3.69922 8.19824 2.23438 6.99707 2.23438 5.21972C2.23438 3.44238 3.69922 2.24121 5.33985 2.24121H14.8028C16.4434 2.24121 17.9082 3.44238 17.9082 5.21972C17.9082 6.99707 16.4434 8.19824 14.8028 8.19824H5.33985Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_5715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.76bfb132006460c4d0b20328169ea2a9.svg";
export { ForwardRef as ReactComponent };